import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clsx } from "clsx";
import { hideAuthModal, showAuthModal } from "store/application/application-action";
import { authModalTabs } from "store/application/application-state";
import { Popup } from "components/UI/Popup";
import AuthSignUp from "./AuthSignUp";
import AuthLogin from "./AuthLogin";
import { IAppState } from "store/app-state";

import "./AuthPopup.scss";

type ITabs = {
  [name in authModalTabs]: string;
};

const TABS: ITabs = {
  login: "Log In",
  signup: "Sign Up",
};

const AuthPopup = () => {
  const { tab } = useSelector((state: IAppState) => state.application.authModal);
  const [currentStep, setCurrentStep] = useState(0);
  const dispatch = useDispatch();

  const togglePopup = () => {
    dispatch(hideAuthModal());
  };

  const handleCurrentTab = (tabValue: string) => {
    const tabIndex = Object.values(TABS).findIndex((value) => {
      return value === tabValue;
    });

    const tab = Object.keys(TABS)[tabIndex] as keyof ITabs;

    dispatch(showAuthModal({ tab }));
  };

  const next = (increment: number = 1) => {
    setCurrentStep(currentStep + increment);
  };

  const prev = (decrement: number = 1) => {
    if (currentStep - decrement >= 0) {
      setCurrentStep(currentStep - decrement);
    }
  };

  const loginCx = clsx("AuthPopup-Tab", { "AuthPopup-Tab_isActive": TABS[tab] === TABS.login });
  const signupCx = clsx("AuthPopup-Tab", { "AuthPopup-Tab_isActive": TABS[tab] === TABS.signup });

  return (
    <Popup
      isOpen
      popupClass="AuthPopup"
      onClose={togglePopup}
    >
      <div className="AuthPopup-Header">
        <button className={loginCx} onClick={() => handleCurrentTab(TABS.login)}>{TABS.login}</button>
        <button className={signupCx} onClick={() => handleCurrentTab(TABS.signup)}>{TABS.signup}</button>
      </div>

      {tab === "signup" && (
        <AuthSignUp
          currentStep={currentStep}
          next={next}
          prev={prev}
        />
      )}

      {tab === "login" && (
        <AuthLogin
          currentStep={currentStep}
          next={next}
          prev={prev}
          onClose={togglePopup}
        />
      )}
    </Popup>
  );
};

export default AuthPopup;
